"use client";

import React, { useState, useContext, useEffect } from "react";
import useWindow from "Hooks/useWindow";
import CookieReader from "Utilities/CookieUtilties/CookieReader";
import { NavigationProvider } from "./Navigation/NavigationContext";
import { ThemeProvider } from "./ThemeContext";
import { UserProvider } from "Contexts/UserContext/UserContext";
import { VehicleStateProvider } from "./VehicleContext";
import { ListStateProvider } from "Contexts/ListContext/ListContext";
import { NotificationProvider } from "Contexts/NotificationContext/NotificationContext";
import { NotificationContainer } from "Atoms/Notification";
import { TrackingProvider } from "Contexts/TrackingContext/TrackingContext";
import { AddToCartExperienceProvider } from "Contexts/AddToCartExperienceContext/AddToCartExperienceContext";
import SetCookie from "Utilities/CookieUtilties/SetCookie";
import { ServicesProvider } from "./ServicesContext/ServicesContext";
import Geolocation from 'UtilityComponents/GeoLocation';


const ExtraContextsThatNewHeaderNeed = ({
  children,
  headerRedesignEnabled,
  services,
  vehicleState,
  updateUserGuid,
  userGuid,
  stateObject,
}) => {
  return headerRedesignEnabled ? (
    <VehicleStateProvider
      userGuid={userGuid}
      updateUserGuid={updateUserGuid}
      services={services}
      vehicleState={vehicleState}
      reloadCurrentLocation={
        stateObject ? stateObject.reloadPageOnVehicleSelection : false
      }
      selectedFacetData={stateObject?.selectedFacetData}
    >
      <ListStateProvider
        userGuid={userGuid}
        updateUserGuid={updateUserGuid}
        services={services}
      >
        <AddToCartExperienceProvider services={services}>
          <NotificationContainer />
          {children}
        </AddToCartExperienceProvider>
      </ListStateProvider>
    </VehicleStateProvider>
  ) : (
    <>{children}</>
  );
};

// if you're considering doing this (don't) https://medium.com/nerd-for-tech/how-to-combine-context-providers-for-cleaner-react-code-9ed24f20225e
// read this instead ... https://medium.com/@webseanhickey/the-evolution-of-a-software-engineer-db854689243
// it's good to know you can/could.. and maybe when you would.
// complexity === hard to change/understand, hard to change/understand === technical debt
// also, why combine the contexts- they should be decoupled from one another
const LayoutProvider = ({
  children,
  headerRedesignEnabled,
  services,
  vehicleState,
  stateObject,
}) => {
  // get rid of this someday once new header is always on
  const [userGuid, setUserGuid] = useState(null);

  useWindow(() => {
    setUserGuid(CookieReader("WebUserGuid"));
  });

  const updateUserGuid = (userGuid) => {
    if (!userGuid) {
      return;
    }

    SetCookie("WebUserGuid", userGuid, 365);
    setUserGuid(userGuid);
  };

  return (
    // <SWRConfig value={{ provider: localStorageProvider }}>
    <ThemeProvider>
      <ServicesProvider services={services}>
        <NotificationProvider>
          <UserProvider
            userGuid={userGuid}
            updateUserGuid={updateUserGuid}
            stateObject={stateObject}
            services={services}
          >
            <Geolocation />
            <NavigationProvider>
              <TrackingProvider>
                <ExtraContextsThatNewHeaderNeed
                  headerRedesignEnabled={headerRedesignEnabled}
                  services={services}
                  vehicleState={vehicleState}
                  stateObject={stateObject}
                  userGuid={userGuid}
                  updateUserGuid={updateUserGuid}
                >
                  {children}
                </ExtraContextsThatNewHeaderNeed>
              </TrackingProvider>
            </NavigationProvider>
          </UserProvider>
        </NotificationProvider>
      </ServicesProvider>
    </ThemeProvider>
    /* </SWRConfig> */
  );
};

export default LayoutProvider;
